export const ValidationErrorMessageStyles = {
  container: 'flex text-red100 flex justify-center max-w-xs',
  message: 'pl-2',
}
